<template>
    <div style="background-color: #F8F9FB;">
        <hhead></hhead>
        <crm-nav></crm-nav>
        <div class="jgMsg_box">
            <div class="jgMsg" :style="{
          minHeight: MHeight,
          boxSizing: 'border-box',
          minWidth: '1300px',
         }">
                <div style="display: flex;" class="searchBox searchBox1" :style="{width:!userMsg.adLevel? '1224px':'1112px'}">
                    <div v-if='!userMsg.adLevel' class="addBtn" @click='exportBtn' style="width: 92px;margin-right: 20px;">
                        <i class="el-icon-plus"></i>导入
                    </div>

                    <div class="se">
                        <el-input v-model='seUserCode' placeholder="请输入账号"></el-input>
                    </div>

                    <div class="se">
                        <el-input v-model='search' placeholder="请输入姓名"></el-input>
                    </div>

                    <div class="se">
                        <el-input v-model='tg_search' placeholder="请输入合作方名称"></el-input>
                    </div>

                    <div class="se">
                        <el-input v-model='contractNum' placeholder="请输入合作编号"></el-input>
                    </div>
                    <div >
                        <el-select multiple   v-model="isEdit" style="width: 220px;"  placeholder="选择账户类型">
                            <el-option v-for="item in editList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </div>

                                <!-- <el-select v-model="value" placeholder="请选择初始规模">
                            <el-option
                            v-for="item in moenyList"
                            :key="item.value"
                            :label="item.name"
                            :value="item.value">
                            </el-option>
                        </el-select> -->

                    <div style="display: flex;margin-top: 15px">
                        <input class="btn" type="button" @click="searchBtn" value="搜索" />
                        <input style="color: #fff;background-color: #5B85FF;" class="btn" type="reset"
                            @click="searchBtn_" value="重置" />
                    </div>


                </div>




                <div class="table" style="margin-top: 40px;">
                    <el-table border :data="resList" size="medium" style="width: 100%"
                        :header-cell-style="{textAlign: 'center'}">
                        <el-table-column align='center' width="60" label="详情">
                            <template slot-scope="scope">
                                <span class="decoration" @click=pushDetail(scope.row.id,scope.row.serverId)
                                    style="color: #5B85FF;cursor: pointer;">查看</span>
                            </template>
                        </el-table-column>
                        <el-table-column width='140' align="center" prop="" label="操作">
                            <template slot-scope="scope">
                                <div v-if="scope.row.edit">
                                    <!-- <span :class="{decoration:scope.row.state==0?true:false}"
                                        @click=start(scope.row.startTime,scope.row.contractNum,scope.row.userName,scope.row.userCode,scope.row.id,scope.row.state)
                                        :style="{color:scope.row.state==2?'#868E99': '#3D6BF1',cursor: 'pointer'}">账户续期</span></span>
                                    <span style="color: #868E99;">丨</span> -->
                                    <span :class="{decoration:scope.row.state==0?true:false}"
                                        @click=stop(scope.row.id,scope.row.userName,scope.row.state)
                                        :style="{color:scope.row.state==2?'#868E99': '#3D6BF1',cursor: 'pointer'}">合作终止</span>
                                        <span style="color: #868E99;">丨</span>
                                        <span :class="{decoration:scope.row.state==0?true:false}"
                                        @click=editBtn(scope.row)
                                        :style="{color:scope.row.state==2?'#868E99': '#3D6BF1',cursor: 'pointer'}">修改</span>

                                </div>
                                <div class="decoration2" @click=editBtn(scope.row,1) v-if="!scope.row.edit"
                                    style="text-align: center;color: #3D6BF1;cursor: pointer;width: 30px;margin: 0 auto;">编辑</div>
                            </template>
                        </el-table-column>

                        <el-table-column align='center'  label="修改密码">
                            <template slot-scope='scope'>
                                <div class="decoration2" @click="editPwdBtn(scope.row)" 
                                    style="text-align: center;color: #3D6BF1;cursor: pointer;width: 30px;margin: 0 auto;">修改</div>
                    
                            </template>

                        </el-table-column>

                        
                        <el-table-column prop="serverManageName" label="私有云名称"
                        align='center'
                      >
                      </el-table-column>


                        <el-table-column align='center' prop="userCode" label="账户">

                        </el-table-column>
                        <el-table-column prop="userName" label="姓名"
            align='center'
          >
          </el-table-column>

         
         
          <el-table-column  align='center'  prop="contractNum" label="合作编号">

                        </el-table-column>
                        <el-table-column prop="cooCycle" align='center' label="合作周期">

                        </el-table-column>
                        <el-table-column prop="simpleName" align='center' label="合作方">

                        </el-table-column>
                        <el-table-column prop="simpleName" align='center' label="账户类型">
                            <template slot-scope="scope">
                                <div>
                                    {{scope.row.accountType=='1'?'投顾账户':scope.row.accountType=='2'?'模拟账户':scope.row.accountType=='3'?'产品账户':scope.row.accountType=='4'?'外部投顾账户':''}}
                                </div>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column   prop="strategyName"  align='center' label="策略">
        </el-table-column>
          <el-table-column  align='right' width="120" prop="capitalScaleName" label="初始规模">
         
        </el-table-column> -->

                        <el-table-column prop='' align='center' width="90" label="状态">
                            <template slot-scope="scope">
                                <span class="stateYuan" v-if="scope.row.edit" :style="{color:scope.row.state==0?'#31b4ff':scope.row.state==2?'#fb6060':'',
                background:scope.row.state==0?'#ebf9ff':scope.row.state==2?'#fff5f4':'',padding:'4px 1px 4px 10px',
                  display:'block',
                  borderRadius: '6px',position:'relative'
              }"><i :style="{display:'inline-block',borderRadius: '50%',width: '5px',height:'5px',
              background:scope.row.state==0?'#31b4ff':scope.row.state==2?'#fb6060':'',position:'absolute',top:'11px',left:'10px'
          }"></i> {{scope.row.state==0?'合作中':(scope.row.state==1?'合作暂停': '已终止')}}</span>
                                <span class="stateYuan" v-if="!scope.row.edit" :style="{color:'#868E99',
                background:'#f1f4f7',padding:'4px 1px 4px 10px',
                  display:'block',
                  borderRadius: '6px',position:'relative'
              }"><i :style="{display:'inline-block',borderRadius: '50%',width: '5px',height:'5px',
              background:'#868E99',position:'absolute',top:'11px',left:'10px'
          }"></i>未编辑</span>
                            </template>
                        </el-table-column>

                        <el-table-column prop='shareMoney' align='right' label="累计分红">
                            <template slot-scope="scope">
                                <span>{{scope.row.shareMoney|format}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="sumNet" width="80" align='right' label="净值">
                            <template slot-scope="scope">
                                <span
                                    :style="{color:scope.row.sumNet>1?'#FA5D22':'#3ABA94'}">{{scope.row.sumNet|num3}}</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column  prop="thisYearProfit" width="90" align='right' label="今年来">
                          <template slot-scope="scope">
                            <span :style="{color:scope.row.thisYearProfit>=0?'#FA5D22':'#3ABA94'}">{{scope.row.thisYearProfit|num}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column   prop="thisMonthProfit" width="90" align='right' label="月内">
                          <template slot-scope="scope">
                            <span :style="{color:scope.row.thisMonthProfit>=0?'#FA5D22':'#3ABA94'}">{{scope.row.thisMonthProfit|num}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  prop= 'profitRate'  width="90" align='right'  label="累计">
                          <template slot-scope="scope">
                            <span :style="{color:scope.row.profitRate>=0?'#FA5D22':'#3ABA94'}">{{scope.row.profitRate|num}}</span>
                          </template>
                        </el-table-column>
                        <el-table-column  prop="yearlyProfitRate" width="90" align='right' label="年化">
                          <template slot-scope="scope">
                            <span :style="{color:scope.row.yearlyProfitRate>=0?'#FA5D22':'#3ABA94'}">{{scope.row.yearlyProfitRate|num}}</span>
                          </template>
                        </el-table-column> -->

                        <el-table-column width='62' align='center' prop="" label="删除">
                            <template slot-scope="scope">
                                <span @click="del(scope.row.id,scope.row.userName)"
                                    style="color: #3D6BF1;cursor: pointer;"
                                    class="iconfont icon-shanchu decoration"></span>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="page_box">
                    <div class="msg_count">共&nbsp;{{ length?length:'0' }}&nbsp;条</div>
                    <div class="blank"></div>
                    <div class="page">
                        <el-pagination background layout="prev, pager, next" :total="pageLength ? pageLength : 0"
                            @current-change="currentPage">
                        </el-pagination>
                    </div>
                </div>


            </div>
        </div>


        <transition name="el-fade-in-linear">
            <!--  添加账户 -->
            <div class="popContainer" v-show="userShow" style="overflow: auto;">
                <div class="add" :style="{ width: '680px',paddingBottom:'20px' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        编辑
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
         " @click="close"></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;">

                            <!--  私有云 -->
                            <!-- <div  class="col" style="margin-bottom: 20px;">
              <div class="left"><span>*&nbsp;</span>私有云</span></div>
              <div class="right" >
                <p>123123</p>
              </div>
            </div> -->

                            <!--  请选择账户 -->
                            <!-- <div  class="col" style="margin-bottom: 20px;">
              <div class="left"><span>*&nbsp;</span>请选择账户</span></div>
              <div class="right" >
                <el-select  @change = "recordChange" filterable  v-model="userVal" placeholder="请选择账户">
                  <el-option
                    v-for="item in userList"
                    :key="item.oldId"
                    :label="item.userCode+'-'+item.userName"
                    :value="item.oldId">
                  </el-option>
                </el-select>
              </div>
            </div> -->



                            <!--  请选择合作方 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>请选择合作方</span></div>
                                <div class="right">
                                    <el-select @change="touguChange" filterable v-model="touguVal" placeholder="请选择合作方">
                                        <el-option v-for="item in touguList" :key="item.id" :label="item.simpleName"
                                            :value="item.id">

                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <!--  初始规模 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>规模范围</span></div>
                                <div class="right">
                                    <el-select v-model="moneyVal" filterable placeholder="规模范围">
                                        <el-option v-for="item in moenyList" :key="item.value" :label="item.name"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>


                            <!--  策略选择 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>策略选择</span></div>
                                <div class="right">
                                    <el-select v-model="strategyVal" filterable multiple placeholder="策略选择">
                                        <el-option v-for="item in strategyList" :key="item.value" :label="item.name"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <!--  合作编号 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作编号</span></div>
                                <div class="right">
                                    <el-select @change="contractChange" v-model="codeVal" filterable placeholder="合作编号">
                                        <el-option v-for="item in codeList" :key="item.id" :label="item.contractNum"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>



                            <!--  起始日期 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>起始日期</span></div>
                                <div class="right">
                                    <el-date-picker v-model="startTime" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择起始日期">
                                    </el-date-picker>
                                </div>
                            </div>



                            <!--  结束日期 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>结束日期</span></div>
                                <div class="right">
                                    <el-date-picker v-model="endTime" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择结束日期">
                                    </el-date-picker>
                                </div>
                            </div>


                            <div class="table"  style="max-height: 310px;overflow-y: auto;width: 104%;" v-if='dividendList.length>0&&tableShow'>
                                <el-table border :data="dividendList" size="medium"
                                    style="margin-left: 50px;width: 90%;" :header-cell-style="{textAlign: 'center'}"
                                    :cell-style="{ textAlign: 'center' }">
                                    <el-table-column prop="contractNum" label="" width='50'
                                        :render-header="renderHeader">
                                        <template slot-scope="scope">
                                            <el-checkbox @change="checkBtn(scope.row.deleted)"
                                                v-model="scope.row.deleted"></el-checkbox>
                                        </template>
                                    </el-table-column>


                                    <el-table-column prop="amount" label="分红金额">
                                    </el-table-column>
                                    <el-table-column prop="time" label="分红日期">

                                    </el-table-column>



                                </el-table>
                            </div>


                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click = "close">取消</button> -->
                        <button @click='submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>





        <transition name="el-fade-in-linear">

            <!--  账户续期 -->
            <div class="popContainer" v-show="Renewal">
                <div class="add" :style="{ width: '680px',paddingBottom:'20px' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        账户续期
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
                         " @click="Renewal_close"></span>
                    <div class="form_box" style="width: 100%;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;">

                            <!-- 合作续期 -->



                            <!--  合起始日 -->
                            <div class="col" style="margin-bottom: 20px;margin-top: 20px;">
                                <div class="left"><span>*&nbsp;</span>起始日期</span></div>
                                <div class="right">
                                    <el-input v-model="xq_startTime" disabled></el-input>
                                </div>
                            </div>

                            <!--  合作结束日 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>结束日期</span></div>
                                <div class="right">
                                    <el-date-picker v-model="xq_endTime" type="date" value-format="yyyy/MM/dd"
                                        placeholder="请选择合作结束日期">
                                    </el-date-picker>
                                </div>
                            </div>

                            <!--  合作编号 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>合作编号</span></div>
                                <div class="right">
                                    <el-input v-model="xq_contractCode" disabled></el-input>
                                </div>
                            </div>

                            <!--  选择投顾方 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>名称</span></div>
                                <div class="right">
                                    <el-input v-model="tg" disabled></el-input>
                                </div>
                            </div>

                            <!--  账户 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>账户</span></div>
                                <div class="right">
                                    <el-input v-model="xq_user" disabled></el-input>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click="Renewal_close">取消</button> -->
                        <button @click='Renewal_submit'>提交</button>
                    </div>
                </div>
            </div>
        </transition>




        <transition name="el-fade-in-linear">

            <!--  导入投顾 -->
            <div class="popContainer" v-show="exportShow">
                <div class="add" :style="{ width: '680px',paddingBottom:'20px' }">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                        导入账号 - 身份验证
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
                     " @click="export_close"></span>
                    <div class="form_box" style="width: 100%;min-height: 100px !important;">
                        <div class="form" style="display: block;width: 480px;margin-left: 58px;min-height: 0;">

                            <!--  导入方式-->
                            <div class="col" >
                                <div class="left" style="margin-top: 0;"><span>*&nbsp;</span>导入方式</div>
                                <div class="right">
                                    <el-radio v-model="radio" label="yunName">私有云名称</el-radio>
                                    <el-radio v-model="radio" label="yunCode_">私有云授权码</el-radio></el-radio>
                                    <p @click='userBtn'  style="font-size: 12px;color: #FFF;cursor: pointer;margin: 10px 0;width:100px;background-color: #62dcb5;line-height: 22px;text-align: center;border-radius: 2px;">导入个人版账号</p>
                                </div>
                              
                            </div>


                            <!--  选择私有云名称-->
                            <div class="col" v-show = "radio=='yunName'" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>私有云名称</div>
                                <div class="right">
                                    <el-select filterable v-model="yunVal" placeholder="请选择">
                                        <el-option v-for="item in yun" :key="item.value" :label="item.name"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <!--  私有云授权码-->
                            <div class="col" v-show = "radio=='yunCode_'" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>私有云授权码</div>
                                <div class="right">
                                    <el-input v-model="yunCode"></el-input>
                                </div>
                            </div>

                            <!--  管理账户 -->
                            <div class="col" style="margin-bottom: 5px;margin-top: -10px;">
                                <div class="left"><span>*&nbsp;</span>账户类型</div>
                                <div class="right">
                                
                                        <el-radio v-model="userType" label="0">管理员</el-radio>
                                        <el-radio v-model="userType" label="1">投顾账户</el-radio>
                                        <!-- <el-radio v-model="userType" label="2">模拟账户</el-radio> -->
                                        <el-radio v-model="userType" label="3">产品账户</el-radio>
                                        <!-- <el-radio v-model="userType" label="4">外部投顾导入</el-radio> -->
                                     
                               
                                </div>
                            </div>

                            <!--  管理账户 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>{{userType=='0'?'管理账户':userType=='1'?'投顾账户':userType=='2'?'模拟账户':userType=='3'?'产品账户':'外部投顾导入'}}</span></div>
                                <div class="right">
                                    <el-input v-model="gl_user"></el-input>
                                </div>
                            </div>

                            <!--  账户密码 -->
                            <div class="col" style="margin-bottom: 20px;">
                                <div class="left"><span>*&nbsp;</span>账户密码</div>
                                <div class="right">
                                    <el-input type="password" v-model="gl_pwd"></el-input>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form_btn">
                        <!-- <button @click="Renewal_close">取消</button> -->
                        <button   @click='export_submit'>验证</button>
                    </div>
                </div>
            </div>
        </transition>


        <transition name="el-fade-in-linear">

            <!--  导入投顾 选择账号-->
            <div class="popContainer" style="z-index: 100;" v-show="userShow_">
                <div class="add"  :style="{ width: '1000px',paddingBottom:'20px',position:'absolute'}">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '1000px' }">
                        导入合作方 - 账号列表
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
             " @click="user_close"></span>
                    <div class="form_box form_boxS" style="width: 100%;min-height: 100px !important">
                        <div class="form" style="display: block;width: 800px;margin: 0 auto;min-height: 0;">

                            <div class="table" style="margin-top: 40px;">
                                <el-table max-height="365px" border size="medium" style="width: 100%"
                                    :data="exportUserList"
                                    :header-cell-style="{textAlign: 'center'}">

                                    <el-table-column prop="userName" :render-header="renderHeader1" v-if = 'checkShow'   align="center"  width="50">
                                        <template slot-scope="scope">
                                            <el-checkbox @change = "checkBtn_(scope.row.deleted)" v-model="scope.row.deleted"></el-checkbox>
                                        </template>
                                      
                                    </el-table-column>

                                    <el-table-column prop="userCode" align='center' label="账户">

                                    </el-table-column>
                                    <el-table-column prop="userName" align='center' label="姓名">

                                    </el-table-column>
                                    <el-table-column v-if ='!flag' prop="serverManageName" align='center' label="私有云名称">

                                    </el-table-column>
                                    <el-table-column v-if ='flag' prop="groupName" align='center' label="合作方">

                                    </el-table-column>
                                    <el-table-column v-if ='flag' prop="productName" align='center' label="隶属产品">

                                    </el-table-column>  
                                    <el-table-column    align='center' label="账户类型">
                                        <template slot-scope="scope">
                                           <div v-show ="!flag" >
                                            {{scope.row.userType=='1'?'投顾账户':scope.row.userType=='2'?'模拟账户':scope.row.userType=='3'?'产品账户':scope.row.userType=='4'?'外部导入账户':''}}
                                           </div>
                                           <div v-show ="flag">
                                            {{scope.row.accountType=='1'?'投顾账户':scope.row.accountType=='2'?'模拟账户':scope.row.accountType=='3'?'产品账户':scope.row.accountType=='4'?'外部导入账户':''}}

                                           </div>
                                        </template>
                                    </el-table-column>
                                     
                                    <el-table-column width="180" :show-overflow-tooltip="true"  align='center' label="进度">
                                        <template slot-scope="scope">                                      
                                            <span v-loading="isArr[scope.$index]?isArr[scope.$index].type=='0':false">{{isArr[scope.$index]?isArr[scope.$index].msg:''}}</span>
                                          
                                        </template>
                                    </el-table-column>

                                </el-table>

                            </div>

                        </div>
                    </div>
                    <p style="margin: 20px 0 50px 90px;" v-if ="isArr.length<=0">已选择{{userLength}}个</p>
                    <el-progress :text-inside="true"
                    style="width: 800px;margin: 15px auto 0;"
                    v-if="speedShow"
                    :stroke-width="16" status="success" :percentage="count_?parseInt(count_*100 / exportUserList.length) :0"></el-progress>
                    <div class="form_btn">
                        <!-- <button @click="Renewal_close">取消</button> -->
                        <button v-if='submitShow' @click='user_submit'>确定</button>
                        <button style="margin-top: 20px;" v-if='!submitShow&&parseInt(count_*100 / exportUserList.length)==100' @click='exportOk'>导入完成</button>
                    </div>
                </div>
            </div>
        </transition>


        <!-- 修改密码 -->
        <transition name="el-fade-in-linear">
            <div class="popContainer" style="z-index: 100;" v-show="pwdShow">
                <div class="add"  :style="{ width: '680px',paddingBottom:'20px',position:'absolute'}">
                    <div class="close"></div>
                    <div class="Top" :style="{ width: '680px' }">
                       修改密码
                    </div>
                    <span class="close iconfont icon-close_round_fill_bold
          " @click="pwd_close"></span>
                    
          <div class="form_box" style="width: 100%;">
            <div class="form" style="display: block;width: 480px;margin-left: 58px;">

              



                <!--  账户 -->
                <div class="col" style="margin-bottom: 20px;margin-top: 20px;">
                    <div class="left"><span>*&nbsp;</span>账户</span></div>
                    <div class="right">
                        <el-input v-model="editPwd.userCode" disabled></el-input>
                    </div>
                </div>

                
              
                
                <!--  新密码 -->
                <div class="col" style="margin-bottom: 20px;margin-top: 20px;">
                    <div class="left"><span>*&nbsp;</span>新密码</span></div>
                    <div class="right">
                        <el-input type="password" show-password v-model="editPwd.newPwd" ></el-input>
                    </div>
                </div>

              

              


            </div>
        </div>
                  
                 
                
                    <div class="form_btn">
                        <!-- <button @click="Renewal_close">取消</button> -->
                        <button @click='editPwdSubmit'>确定</button>
                   
                    </div>
                </div>
            </div>
        </transition>
        <!-- 修改密码 -->


    </div>
</template>
<script>
    import hhead from '../header/index';
    import crmNav from '../../../components/crmNav/index';
    import './style.css';
    export default {
        components: { hhead, crmNav },
        data() {
            return {
                btnDisabled:true,
                userMsg:JSON.parse(localStorage.getItem('once')),
                tableShow:true,
                flag:true,// true 输入账号密码导入 false导入已有账号
                radio:'yunName',
                isEdit: [] ,//账户类型
                seUserCode:'',//搜索账户
                userid: '',
                userType:'0',//账户类型
                submitShow:true,
                speedShow:false,//进度
                checkShow:true,
                exportUserList:[],
                count_:0,//进度条完成数量
                exportShow: false,
                userShow_: false,//选择账号遮罩层
                xq_startTime: '',//账户起始日
                xq_endTime: '',//账户结束日
                xq_contractCode: '',//合作编号
                tg: '',//名称
                userId: '',
                gl_user: '',// 管理账户
                gl_pwd: '',//账户密码
                xq_user: '',//账户
                pageLength: null, //分页长度
                page: 0,
                length: '', //账户列表总数
                MHeight: document.documentElement.clientHeight - 94 + 'px',
                resList: [],
                Renewal: false,//账户续期
                userShow: false,
                search: '',//账户搜索
                tg_search: '',//投顾搜索
                userLength:0,//已选择账号数量
                yun: [],//私有云
                yunVal: '',//私有云的value
                yunCode:'',//私有云授权码
                userList: [],//选择账户
                userVal: '',//账户value
                touguList: [],//投顾列表
                touguVal: '',//选择投顾value
                strategyList: [],//策略列表
                strategyVal: '',//策略value
                moenyList: [],//初始规模列表
                moneyVal: '',//初始规模value
                codeList: [],//合作编号列表
                codeVal: '',//合作编号值
                startTime: '',//起始日期
                endTime: '',//结束日
                dividendList: [],//分红列表
                shareOldId: '',//分红id
                contractNum: '',//合作编号
                isArr:[],
                pwdShow:false,//修改密码
                editList: [{
                    label: '投顾账户',
                    value: 1
                }, 
                // { label: '模拟账户', value: 2 }, 
                { label: '产品账户', value: 3 },
                // { label: '外部导入账户', value: 4 }
                ],
                editVal: '',
                check__:false,//导入账号全选框
                options: [],
                value: '',

                editPwd:{
                    userCode:'',
                    id:'',
                    newPwd:'',
                 
                },//修改密码

                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                shortcuts: [{
                    text: 'Today',
                    value: new Date(),
                }, {
                    text: 'Yesterday',
                    value: (() => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24)
                        return date
                    })(),
                }, {
                    text: 'A week ago',
                    value: (() => {
                        const date = new Date()
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
                        return date
                    })(),
                }],
            };
        },
        filters: {
            datas: function (date) {
                return date.substr(0, 10).replace(/\//g, '-')
            },

            num: function (n) { //数字格式化
                return (Math.round(n * 10000) / 100).toFixed(2) + '%'
            },
            num3: function (n) { //数字格式化
                if (n) {
                    return n.toFixed(4)
                }
            },
            format: function (n) {
                if (n) {
                    
                    return n.toFixed(2)
                } else {
                    return '0.00'
                }
            }
        },

        mounted() {
            
            
            this.list()
            this.$axios.post( //初始规模
                '/crm/acc/queryInitBalance',
                { apiToken: this.$store.state.usermsg.apiToken, }
            ).then(res => {
                // // console.log(res)
                if (res.data.code == 200) {
                    this.moenyList = res.data.data
                }
            })


            this.$axios.post( //获取私有云
                '/crm/acc/choseServer',
                { apiToken: this.$store.state.usermsg.apiToken }
            ).then(res => {
                if (res.data.code == 200) {
                    this.yun = res.data.data
                }
                console.log(res)
            })

        },
        methods: {
            exportOk(){//导入完成按钮
                window.location.reload()
            },
            userBtn(){//导入已有账号按钮
                this.$confirm('导入个人版账号之后全部机构成员可见，可通过权限进行设置，继续导入请点击“确定”', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(()=>{

                    this.flag = false
                    this.exportShow = false
                    this.userShow_ = true
                    this.$axios.post(
                        '/crm/acc/get_acc_list',
                        {apiToken: this.$store.state.usermsg.apiToken}
                    ).then(res=>{
                        console.log(res)
                        if(res.data.code == 200){
                            this.exportUserList = res.data.datas
                        }
                    }).catch(err=>{
                        console.log(err)
                    })
                }).catch(()=>{})
            },
            exportBtn() {
                this.exportShow = true
            },
            export_close() {
                this.exportShow = false
                this.clear()
            },
            user_submit() { //提交选择账号
                let arr = []
                let i = 0
                this.exportUserList.forEach(item=>{
                    if(item.deleted){
                        item.success =false
                        arr.push(item)
                        
                    }
                })
                if(arr.length>0){
                    this.checkShow = false
                    this.speedShow = true
                    this.submitShow = false
                    this.exportUserList = arr
                    this.forAxios(i)
                }else{
                    this.$alert('请选择账户', {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true
                        }).then(() => { }
                        ).catch(() => { });
                }
            },
            forAxios(i){
                
                // console.log(this.isArr  )
                this.isArr.push({type:'0',msg:'导入中'})
                if(this.flag){ //输入账号密码导入

                    this.$axios.post(
                        '/crm/acc/batchAddAcc',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            oldId:this.exportUserList[i].oldId,
                            serverId:this.exportUserList[i].serverId,
                            accountType:this.exportUserList[i].accountType
                        }
                    ).then(result=>{
                            console.log(result)
                            document.getElementsByClassName('form_boxS')[0].scrollTop = 0
                            
                            if(result.data.code == 200){
                                this.isArr[i] = {type:'1',msg:'导入成功'}
                                this.isArr.push({type:'0',msg:'导入中'})
                                this.isArr.pop()
                                this.count_ ++
                                i++
                                if(i<this.exportUserList.length){
                                    this.forAxios(i)
                                }
                            }else{
                                this.isArr[i]= {type:'2',msg:result.data.message}
                                this.isArr.push({type:'0',msg:'导入中'})
                                this.isArr.pop()
                                this.count_ ++
                                i++
                                if(i<this.exportUserList.length){
                                    this.forAxios(i)
                                }
                              
                            }
                            // if(i==this.exportUserList.length){
                            //     this.$alert('导入完成', {
                            //         confirmButtonText: '确定',
                            //         type: 'success',
                            //         center: true
                            //     }).then(() => {window.location.reload() }
                            //     ).catch(() => {window.location.reload() });
                            // }
                            
                            document.getElementsByClassName('form_boxS')[0].scrollTop = i*40
                           
                    }).catch(err=>{
                        console.log('导入失败')
                    })
                }else{ //导入已有账号
                    this.$axios.post(
                        '/crm/acc/add_acc_list',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            id:this.exportUserList[i].id,
                            accountType:this.exportUserList[i].userType,
                        }
                    ).then(result=>{
                            console.log(result)
                            document.getElementsByClassName('form_boxS')[0].scrollTop = 0
                            
                            if(result.data.code == 200){
                                this.isArr[i] = {type:'1',msg:'导入成功'}
                                this.isArr.push({type:'0',msg:'导入中'})
                                this.isArr.pop()
                                this.count_ ++
                                i++
                                if(i<this.exportUserList.length){
                                    this.forAxios(i)
                                }
                            }else{
                                this.isArr[i]= {type:'1',msg:result.data.message}
                                this.isArr.push({type:'0',msg:'导入中'})
                                this.isArr.pop()
                                this.count_ ++
                                i++
                                if(i<this.exportUserList.length){
                                    this.forAxios(i)
                                }
                              
                            }
                            // if(i==this.exportUserList.length){
                            //     this.$alert('导入完成', {
                            //         confirmButtonText: '确定',
                            //         type: 'success',
                            //         center: true
                            //     }).then(() => {window.location.reload() }
                            //     ).catch(() => {window.location.reload() });
                            // }
                            
                            document.getElementsByClassName('form_boxS')[0].scrollTop = i*40
                           
                    })
                }
            },
            user_close() {//关闭选择账号
                if(this.submitShow){

                    this.userShow_ = false
                    this.flag = true
                    this.clear()
                }else{
                    window.location.reload()
                }
            },
            export_submit() {
                
                if( this.btnDisabled){
                    this.btnDisabled = false

                    if(this.userType=='0'){ //管理员
    
                        this.$axios.post(
                            '/crm/acc/choseAcc',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                type:this.radio =='yunName'?0:1,
                                serverId: this.yunVal,
                                account: this.gl_user.trim(),
                                password: this.gl_pwd,
                                authCode:this.radio=='yunCode_'?this.yunCode.trim():''
                            }
                        ).then(res => {
                            console.log(res)
                            if (res.data.code == 200) {
                                this.exportUserList = res.data.data
                                this.exportShow = false
                                this.userShow_ = true
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => { }
                                ).catch(() => { });
                            }
        
                            // console.log(res)
                            setTimeout(()=>{

                                this.btnDisabled = true
                            },1000)
                        })
                    }else{
                        this.$axios.post( //投顾
                            '/crm/acc/add_one_acc',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                type:this.radio =='yunName'?0:1,
                                serverId: this.yunVal,
                                userCode: this.gl_user.trim(),
                                password: this.gl_pwd,
                                authCode:this.radio=='yunCode_'?this.yunCode.trim():'',
                                accountType:this.userType
                            }
                        ).then(res => {
                            console.log(res)
                            if (res.data.code == 200) {
                                // this.exportUserList = res.data.data
                                this.exportShow = false
                                // this.userShow_ = true
                                this.list()
                                this.clear()
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => { }
                                ).catch(() => { });
                            }
        
                            // console.log(res)
                            setTimeout(()=>{

                            this.btnDisabled = true
                            },1000)
                          })
                     }
                }
            },
            renderHeader(h, { column }) {
                return (
                    'span',
                    [
                        h('el-checkbox', {
                            on: {
                                change: this.select
                            }
                        }),
                        h('span', column.label)
                    ]
                )
            },
            renderHeader1(h, { column }) {
                return (
                    'span',
                    [
                        h('el-checkbox', {
                            on: {
                                change: this.select1
                            },
                            props: {
                              value: this.check__ //文字框的内容取决于这个value，如果value不存在，会报错
                     }
                        }),
                        h('span', column.label)
                    ]
                )
            },
            
            editBtn(row,show) { //编辑
                if(row.state !=2){

                    if(show){
                        this.tableShow = true
                        this.$axios.post(
                            '/crm/acc/queryAllAcc',
                            { apiToken: this.$store.state.usermsg.apiToken,
                                id:row.id
                            }

                        ).then(res=>{
                            console.log(res)
                            if(res.data.code == 200){
                                var arr = []
                                res.data.data[0].strategyList.forEach(item=>{
                                    arr.push(item.dictionaryId + '')
                                })
                                this.strategyVal = arr
                                this.touguVal = res.data.data[0].investorId
                                this.startTime =res.data.data[0].startTime? res.data.data[0].startTime.substr(0,10):''
                                this.endTime =res.data.data[0].endTime?res.data.data[0].endTime.substr(0,10):''
                                this.touguChange()
                                this.moneyVal = res.data.data[0].capitalScale 
                                this.codeVal = res.data.data[0].contractId

                            }
                        })
                    }else{
                        this.tableShow = false 
                        this.$axios.post(
                            '/crm/acc/queryAllAcc',
                            { apiToken: this.$store.state.usermsg.apiToken,
                                id:row.id
                            }

                        ).then(res=>{
                            console.log(res)
                            if(res.data.code == 200){
                                var arr = []
                                res.data.data[0].strategyList.forEach(item=>{
                                    arr.push(item.dictionaryId + '')
                                })
                                this.strategyVal = arr
                                this.touguVal = res.data.data[0].investorId
                                this.startTime = res.data.data[0].startTime.substr(0,10)
                                this.endTime =res.data.data[0].endTime.substr(0,10)
                                this.touguChange()
                                // console.log(this.moenyList)
                                this.moneyVal = res.data.data[0].capitalScale + ''
                                this.codeVal = res.data.data[0].contractId
                                // console.log(this.touguVal)
                            }
                        })
                    }
                   
                    // this.touguVal = row.id
                    this.userShow = true
                    this.userid = row.id
    
                    this.$axios.post( //选择投顾
                        '/crm/inverstor/queryAllInverstor',
                        { apiToken: this.$store.state.usermsg.apiToken, }
                    ).then(res => {
                        // // console.log(res)
                        if (res.data.code == 200) {
                            this.touguList = res.data.data
                        }
                    })
    
    
                    this.$axios.post( //策略选择
                        '/crm/acc/queryStrategyType',
                        { apiToken: this.$store.state.usermsg.apiToken, }
                    ).then(res => {
                        // console.log(res,'cl')
                        if (res.data.code == 200) {
                            this.strategyList = res.data.data
                        }
                    })
    
                    this.recordChange(row.serverId, row.oldId)
                }else{
                    this.$alert('合作已终止', {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }
                            ).catch(() => { });
                }

            },
            /** 是否勾选表头 */
            select(checked) {
                // 如果checked为true则是勾选了对应的表头
                // console.log(checked)
                if (checked) {

                    this.dividendList.forEach((item, index) => {
                        item.deleted = true

                    })

                } else {
                    this.dividendList.forEach(item => {
                        item.deleted = false

                    })
                }
            },
            select1(checked){

                if (checked) {
                    this.check__ = true
                    this.userLength = this.exportUserList.length
                this.exportUserList.forEach((item, index) => {
                    item.deleted = true

                })

                } else {
                    this.check__ = false
                    this.userLength = 0
                this.exportUserList.forEach(item => {
                    item.deleted = false

                })
                }
            },
            currentPage(e) {
                //当前页
                this.page = e;
                this.list();
            },
            Renewal_close() { // 取消 账户续期
                this.Renewal = false
                this.xq_endTime = ''
            },
            Renewal_submit() {// 提交 账户续期
                if (this.xq_endTime) {
                    this.$axios.post(
                        '/crm/acc/renew',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            time: this.xq_endTime,
                            id: this.userId
                        }
                    ).then(res => {
                        // console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            this.list()
                            this.Renewal_close()
                            //             this.$alert('续期成功', {
                            //   confirmButtonText: '确定',  
                            //   type: 'success',
                            //   center: true
                            // }).then(() => {}
                            // ).catch(() => {});
                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }
                            ).catch(() => { });
                        }
                    })
                }
            },
            pushDetail(id, serverId) {
                //详情
                window.open('_blank').location.href = `/crm/user/uDetails?id=${id}&serverId=${serverId}`
            },
            searchBtn() {
                //搜索
                this.$axios.post(
                    '/crm/acc/queryAllAcc',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        userCode:this.seUserCode,
                        investorName: this.tg_search,
                        accountTypes: this.isEdit,
                        userName: this.search,
                        contractNum: this.contractNum,
                        page_no: 1,
                        size: 10000,
                    }
                ).then(res => {
                       console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.resList = res.data.data
                        this.length = res.data.data.length
                        this.pageLength = Math.ceil(res.data.data.length / 1.5)

                    }
                })

            },
            searchBtn_() {
                //投顾名称搜索
                this.seUserCode = ''
                this.isEdit = []
                this.tg_search = ''
                this.search = ''
                this.contractNum = ''
                this.value = ''
                this.searchBtn()
            },
            checkBtn(checked) {
                checked = !checked
                
            },
            checkBtn_(checked){
                checked = !checked
                var num = 0
                this.exportUserList.forEach(item=>{
                    if(item.deleted){
                        num++
                    }
                })
                this.userLength = num
            },
            submit() {

                if (this.touguVal && this.strategyVal && this.moneyVal && this.codeVal && this.startTime && this.endTime) {
                    this.userVal
                    let userName = ''
                    let userCode = ''
                    this.userList.forEach(item => {
                        if (item.oldId == this.userVal) {
                            userCode = item.userCode
                            userName = item.userName
                        }
                    })
                    let time = ''
                    let num = ''
                    this.dividendList.forEach(item => {
                        if (item.deleted) {
                            time += ',' + item.time.substr(0, 10)
                            num += ',' + item.amount
                            this.shareOldId += ',' + item.id
                        }
                    })


                    this.$axios.post(

                       this.tableShow?'/crm/acc/addAcc':'/crm/acc/editAcc',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            // serverId:this.yunVal,
                            // oldId:this.userVal,
                            id: this.userid,
                            contractId: this.codeVal,
                            investorId: this.touguVal,
                            startTime: this.startTime,
                            state: 0,
                            capitalScale: this.moneyVal,
                            endTime: this.endTime,
                            strategyTypes: this.strategyVal,
                            userName: userName,
                            userCode: userCode,
                            shareTimes: time.replace(',', ''),
                            shareMoneys: num.replace(',', ''),
                            shareOldId: this.shareOldId.replace(',', ''),
                            shareMoney: 1
                        },
                    ).then(res => {
                        // console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            this.clear()
                            this.list()
                        } else {
                            this.$alert(res.data.message, {
                                confirmButtonText: '确定',
                                type: 'error',
                                center: true
                            }).then(() => { }
                            ).catch(() => { });
                        }
                    }).catch(err => {
                        // console.log(err)
                    })

                } else {
                    this.$alert('验证错误:请确认信息是否填写完整', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    }).then(() => { }
                    ).catch(() => { });
                }
            },
            recordChange(serverId, oldAccId) {
                //出入金记录list
                // console.log(this.userVal)
                this.$axios.post(
                    '/crm/acc/queryShare',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        serverId: serverId,
                        oldAccId: oldAccId
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.dividendList = res.data.data
                    } else {
                        this.$alert(res.data.message, {
                            confirmButtonText: '确定',
                            type: 'error',
                            center: true
                        }).then(() => { }
                        ).catch(() => { });
                    }
                })
            },
            touguChange() {
                //选择投顾获取合作列表
                this.$axios.post(
                    '/crm/contract/queryAllContract',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        investorId: this.touguVal
                    }
                ).then(res => {
                    this.tokenInvalid(res)
                    // console.log(res)
                    if (res.data.code == 200) {
                        this.codeList = res.data.data
                    }
                })
            },
            contractChange(e){//选择合作获取时间
                this.$axios.post(
                    '/crm/contract/queryOneContract',
                    {apiToken: this.$store.state.usermsg.apiToken,
                        entConId:e
                    }
                ).then(res=>{
                    this.tokenInvalid(res)
                    // console.log(res)
                    if(res.data.code == 200){
                        this.startTime = res.data.data.startTime.substr(0,10)
                        this.endTime = res.data.data.endTime.substr(0,10)
                    }
                })
            },  
            close() {
                this.userShow = false
                this.clear()
            },
            add() {
                this.userShow = true


                //   this.$axios.post( //私有云
                //     '/crm/acc/choseServer',
                //     {apiToken:this.$store.state.usermsg.apiToken,}
                //   ).then(res=>{
                //     this.tokenInvalid(res)
                //     // // console.log(res)
                //     if(res.data.code == 200){
                //       this.yun = res.data.data
                //     }else{
                //       this.$alert(res.data.message, {
                //       confirmButtonText: '确定',  
                //       type: 'error',
                //       center: true
                //     }).then(() => {}).catch(() => {});
                //     }
                //   })






            },
            start(startTime, contractNum, userName, userCode, id, state) {
                if (state != 2) {

                    this.Renewal = true
                    this.xq_startTime = startTime
                    this.xq_contractCode = contractNum
                    this.tg = userName
                    this.xq_user = userCode
                    this.userId = id
                } else {
                    this.$alert('合作已终止', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    })
                }


            },
            stop(id, user, state) {
                //合作终止
                if (state != 2) {

                    this.$confirm(`您确定要终止合作账户“${user}”吗`, {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true
                    }).then(() => {
                        this.$axios.post(
                            '/crm/acc/stopOrStart',
                            {
                                apiToken: this.$store.state.usermsg.apiToken,
                                id: id,
                                state: 2,
                            }
                        ).then(res => {
                            // console.log(res)
                            this.tokenInvalid(res)
                            if (res.data.code == 200) {
                                this.list()
                                //       this.$alert('操作成功', { 
                                //   confirmButtonText: '确定',  
                                //   type: 'success',
                                //   center: true
                                // }).then(() => {}).catch(() => {});
                            } else {
                                this.$alert(res.data.message, {
                                    confirmButtonText: '确定',
                                    type: 'error',
                                    center: true
                                }).then(() => { }).catch(() => { });
                            }
                        })
                    }).catch(() => {

                    });
                } else {
                    this.$alert('合作已终止，请勿重复操作', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        center: true
                    }).then(() => { }).catch(() => { });
                }
            },



            del(id, user) {
                //删除账户

                this.$axios
        .post("/crm/acc/queryGroupAcc", {
          apiToken: this.$store.state.usermsg.apiToken,
          accId: id
        })
        .then(r => {
          this.$confirm(
            `${
              r.data.code == 200
                ? "账户" + "“" + user + "”" + "已绑定投资经理，确定删除吗"
                : "确定删除账户" + "“" + user + "”" + "吗"
            }`,
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
            }
          )
            .then(() => {
                  this.$axios.post(
                        '/crm/acc/del',
                        {
                            apiToken: this.$store.state.usermsg.apiToken,
                            accId: id,
                        }
                    ).then(res => {
                        // console.log(res)
                        this.tokenInvalid(res)
                        if (res.data.code == 200) {
                            this.list()
                            // this.$alert('删除成功', {
                            //     confirmButtonText: '确定',
                            //     type: 'success',
                            //     center: true
                            // }).then(() => { }).catch(() => { });
                        }
                    })
               
            })
            .catch(() => {});
        });


              
                  
               
            },
            list() {
                this.$axios.post(
                    '/crm/acc/queryAllAcc',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        investorName: this.tg_search,
                        userName: this.search,
                        accountTypes: this.isEdit,
                        contractNum: this.contractNum,
                        page_no: 1,
                        size: 100000,
                    }
                ).then(res => {
                    // console.log(res,111)
                    //    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.length = res.data.data.length
                        this.pageLength = Math.ceil(res.data.data.length / 1.5)

                    }
                })


                //获取所有合作
                this.$axios.post(
                    '/crm/acc/queryAllAcc',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        investorName: this.tg_search,
                        userName: this.search,
                        accountTypes: this.isEdit,
                        contractNum: this.contractNum,
                        page_no: this.page,
                        size: 15,
                    }
                ).then(res => {
                    // console.log(res)
                    this.tokenInvalid(res)
                    if (res.data.code == 200) {
                        this.resList = res.data.data

                    }
                })
            },
            editPwdBtn(e){//修改密码
                console.log(e)
                this.pwdShow = true
                this.editPwd.id = e.id
                this.editPwd.userCode = e.userCode
            },
            pwd_close(){
                this.pwdShow = false
                this.editPwd.newPwd = ''
            },
            editPwdSubmit(){//修改密码提交
                if(this.editPwd.newPwd){
                    this.$axios.post(
                    '/crm/acc/uapUserPwd',
                    {
                        apiToken: this.$store.state.usermsg.apiToken,
                        id:this.editPwd.id,
                        password:this.editPwd.newPwd
                    }
                ).then(res=>{
                    let that = this
                    console.log(res)
                    if(res.data.code == 200){
                        this.editPwd = ''
                        this.$alert(res.data.message, {
                        confirmButtonText: '确定',
                        type: 'success',
                        center: true
                    }).then(() => {
                        this.pwdShow = false
                      
                     }).catch(() => { 
                        this.pwdShow = false
                     }); 
                    }else{
                        this.$alert(res.data.message, {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    }).then(() => { }).catch(() => { });  
                    }
                })
                }else{
                    this.$alert('请输入新密码', {
                        confirmButtonText: '确定',
                        type: 'error',
                        center: true
                    }).then(() => { }).catch(() => { });
                }
            },
            clear() {
                //清除输入框
                this.userShow = false
                this.search = ''//搜索
                this.userLength = 0
                this.gl_user= '',// 管理账户
                this.gl_pwd= '',
                this.yunCode = '' //私有云授权码
                        this.account= this.gl_user,
                        this.password= this.gl_pwd
                // this.yun = []//私有云
                this.yunVal = ''//私有云的value
                this.userList = []//选择账户
                this.userVal = ''//账户value
                this.touguList = []//投顾列表
                this.touguVal = ''//选择投顾value
                this.strategyList = []//策略列表
                this.strategyVal = ''//策略value
                //    this.moenyList=[]//初始规模李彪
                this.moneyVal = ''//初始规模value
                this.codeList = []//合作编号列表
                this.codeVal = ''//合作编号值
                this.startTime = ''//起始日期
                this.endTime = ''//结束日
                this.dividendList = []//分红列表

            },
            // yunChange() {
            //     //选着私有云，请求账户数据
            //     // console.log()
            //     this.$axios.post(
            //         '/crm/acc/choseAcc',
            //         {
            //             apiToken: this.$store.state.usermsg.apiToken,
            //             serverId: this.yunVal
            //         }
            //     ).then(res => {
            //         // console.log(res)
            //         this.tokenInvalid(res)
            //         if (res.data.code == 200) {
            //             this.userList = res.data.data
            //         }

            //     })
            // },


        },
        
    };
</script>


// WEBPACK FOOTER //
// src/view/crm/user/index.vue